import moment from "moment";
import { useMemo } from "react";
import { formatToCommaSeparatedString } from "utils/HelperFunctions";
import { isObjectEmpty } from "utils/helpers";
import { MAGNET_RELEASE_STATUS, READABLE_DATE_FORMAT } from "../../constants";

type ValidRelease = Release & {
  status: ReleaseStatus;
};

type Props = {
  name: string;
  imageUrl: string;
  release: Release | {};
  hideComingSoon?: boolean;
};

function TrendingMagnetCard({ name, imageUrl, release, hideComingSoon }: Props) {
  const getHeadingAndSubHeading = (releaseObj: Release | {}) => {
    if (isObjectEmpty(releaseObj)) {
      return {
        heading: "Coming Soon",
        subHeading: "Be on the lookout",
      };
    }

    const validRelease = release as ValidRelease;

    switch (validRelease.status) {
      case MAGNET_RELEASE_STATUS.ON_SALE:
        return {
          heading: `Price: ${formatToCommaSeparatedString(validRelease.price, "currency")}`,
          subHeading: "On Sale Now",
        };
      case MAGNET_RELEASE_STATUS.SCHEDULED:
        return {
          heading: `Price: ${formatToCommaSeparatedString(validRelease.price, "currency")}`,
          subHeading: `Releasing on: ${moment(validRelease.start_time).format(READABLE_DATE_FORMAT)}`,
        };
      default:
        return {
          heading: "",
          subHeading: "",
        };
    }
  };

  const magnetSubText = useMemo(() => getHeadingAndSubHeading(release), [release]);

  return (
    <div className="magnet-price-card-background w-72 rounded-2xl border border-white p-2 2xl:w-80 2xl:p-3 4xl:w-96">
      <div className="aspect-h-1 aspect-w-1 cursor-pointer">
        <img
          src={imageUrl}
          alt={`${name}_trending_magnet`}
          className="h-full w-full rounded-2xl border border-white object-cover"
        />
      </div>
      <div className="flex h-32 flex-col justify-between 2xl:h-40">
        <div
          className=" mt-2 line-clamp-2 text-left font-satoshi text-2xl
        font-bold leading-tight text-primary first-letter:uppercase 2xl:text-3xl"
        >
          {name}
        </div>
        <div className="flex flex-col -space-y-1 text-start">
          {hideComingSoon ? null : (
            <>
              <p className="font-satoshi text-lg font-bold text-primary 2xl:text-xl">{magnetSubText.heading}</p>
              <div className="font-sora text-xs font-semibold text-primary opacity-80 2xl:text-sm">
                {magnetSubText.subHeading}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export default TrendingMagnetCard;
